import React from 'react';
import { Link } from 'react-router-dom';
import './AreasOfFocus.css';

const AreasOfFocus = () => {
  const areas = [
    {
      category: "Mental Health",
      topics: [
        "Anxiety Disorders",
        "Depression",
        "Bipolar Disorder",
        "Obsessive-Compulsive Disorder (OCD)",
        "Post-Traumatic Stress Disorder (PTSD)"
      ]
    },
    {
      category: "Life Challenges",
      topics: [
        "Grief and Loss",
        "Relationship Issues",
        "Family Dynamics",
        "Career Transitions",
        "Academic Stress"
      ]
    },
    {
      category: "Personal Development",
      topics: [
        "Self-Esteem Building",
        "Confidence Development",
        "Goal Setting",
        "Stress Management",
        "Mindfulness Practice"
      ]
    },
    {
      category: "Specialized Populations",
      topics: [
        "Adolescents and Young Adults",
        "Adults",
        "Seniors",
        "LGBTQ+ Community",
        "Veterans and First Responders"
      ]
    }
  ];

  const specializedAreas = [
    {
      title: "Grief",
      description: "Specialized support for navigating loss, bereavement, and the complex emotions that accompany grief.",
      link: "/areas-of-focus/grief",
      icon: "🕊️"
    },
    {
      title: "Dreams",
      description: "Exploring the unconscious mind through dream work and symbolic interpretation for deeper self-understanding.",
      link: "/areas-of-focus/dreams",
      icon: "🌙"
    },
    {
      title: "Spiritual Integration",
      description: "Integrating spiritual beliefs and practices with therapeutic work for holistic healing and growth.",
      link: "/areas-of-focus/spiritual-integration",
      icon: "✨"
    }
  ];

  return (
    <div className="areas-of-focus">
      <div className="areas-container">
        <div className="areas-header">
          <h1>Areas of Focus</h1>
          <p>
            I specialize in helping clients navigate a wide range of mental health challenges 
            and life circumstances. Each area represents my expertise and commitment to providing 
            effective, compassionate care.
          </p>
        </div>
        
        <div className="specialized-areas-section">
          <h2>Specialized Focus Areas</h2>
          <p>
            I have developed particular expertise in these three areas, which require specialized 
            approaches and understanding. Click on each area to learn more about my specific 
            methods and experience.
          </p>
          <div className="specialized-areas-grid">
            {specializedAreas.map((area, index) => (
              <Link key={index} to={area.link} className="specialized-area-card">
                <div className="specialized-area-icon">{area.icon}</div>
                <h3>{area.title}</h3>
                <p>{area.description}</p>
                <span className="learn-more">Learn More →</span>
              </Link>
            ))}
          </div>
        </div>
        
        <div className="areas-grid">
          {areas.map((area, index) => (
            <div key={index} className="area-card">
              <h2>{area.category}</h2>
              <ul>
                {area.topics.map((topic, topicIndex) => (
                  <li key={topicIndex}>{topic}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="areas-commitment">
          <h2>My Commitment to You</h2>
          <p>
            Regardless of the specific challenges you're facing, I'm committed to providing 
            a safe, supportive environment where you can explore your experiences and work 
            toward meaningful change. Every client is unique, and I tailor my approach to 
            meet your individual needs and goals.
          </p>
          <p>
            If you don't see your specific concern listed here, please don't hesitate to reach out. 
            I'm happy to discuss how I can help with your particular situation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AreasOfFocus;
